import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class DefaultStrat extends Strategy {

    public hasCondition(request: OperationRequest): boolean {
        const hasOperationSupport = request.hasOperationSupport;
        if (!hasOperationSupport && !request.nextOperation) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.FINISHOPERATION;
    }
}
